module.exports = __webpack_public_path__ + "img/error.709057a0.svg";